import React from 'react';
import Svg, { G, Path, Mask, Rect } from 'react-native-svg';

export function BrowserIcon() {
    return (
        <Svg width="32" height="32" fill="none" viewBox="0 0 32 32">
            <G>
                <Path
                    d="M15.9998 29.3333C23.3636 29.3333 29.3332 23.3638 29.3332 16C29.3332 8.63616 23.3636 2.66663 15.9998 2.66663C8.63604 2.66663 2.6665 8.63616 2.6665 16C2.6665 23.3638 8.63604 29.3333 15.9998 29.3333Z"
                    stroke="#767676"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <Path
                    d="M2.6665 16H29.3332"
                    stroke="#767676"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <Path
                    d="M15.9998 2.66663C19.3349 6.31776 21.2302 11.056 21.3332 16C21.2302 20.9439 19.3349 25.6822 15.9998 29.3333C12.6648 25.6822 10.7695 20.9439 10.6665 16C10.7695 11.056 12.6648 6.31776 15.9998 2.66663Z"
                    stroke="#767676"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </G>
        </Svg>
    );
}

export function IndeedIcon() {
    const INDEED_LOGO_SVG_ID = 'app-download-promo-logo';
    return (
        <Svg fill="none" viewBox="0 0 36 36" width="48" height="48">
            <Mask
                id={INDEED_LOGO_SVG_ID}
                x="8"
                y="6"
                width="17"
                height="24"
                maskUnits="userSpaceOnUse"
            >
                <Path
                    fill="#fff"
                    fillRule="evenodd"
                    d="M23.4808 7.80716c-2.0479-1.7779-4.7746-1.82433-7.1674-.95831C12.839 8.3035 10.423 11.4783 9.33009 15.2884c-.18405.7156-.33365 1.4316-.41418 2.1703 0 .0026-.00072.0141-.00187.0322-.00902.1428-.044.6962.04801.5218.07725-.1292.12246-.3036.16441-.4655.01419-.0547.02801-.108.04257-.1577.52917-1.7895 1.17337-3.4174 2.16277-4.9645 2.37-3.49794 6.178-5.74938 10.2047-4.50261.7477.25396 1.415.62356 2.0822 1.06232.0087.00634.0212.01574.0369.02752.2123.15971 1.0073.75764.8145.13407-.1726-.53113-.6098-.98152-.9893-1.33914zM19.374 15.9336c-1.4935.7646-3.3216.1673-4.0742-1.3262-.7647-1.4935-.1673-3.3214 1.3261-4.0744 1.4936-.76448 3.3216-.1672 4.0743 1.3263.7647 1.4935.1672 3.3215-1.3262 4.0743zm-3.5407 11.311V18.429c.2709.0241.5287.0361.7996.0361 1.2897 0 2.502-.3237 3.5338-.8984v9.6779c0 .8266-.2064 1.4375-.6063 1.8446-.3997.4071-.9284.6108-1.5733.6108-.632 0-1.1349-.2037-1.5476-.6229-.3998-.4071-.6062-1.018-.6062-1.8325z"
                    clipRule="evenodd"
                />
            </Mask>
            <G mask={`url(#${INDEED_LOGO_SVG_ID})`}>
                <Rect x="5" y="5" width="26" height="26" fill="#2557A7" />
            </G>
        </Svg>
    );
}
